import styled from '@emotion/styled';
import classNames from 'classnames';
import React, { CSSProperties, PropsWithChildren } from 'react';

type Props = {
  checkIcon?: React.ReactNode;
  checked?: boolean | 'mixed';
  onClick?: () => void;
  style?: CSSProperties;
  className?: string;
  isSelected?: boolean;
  multiSelect?: boolean;
};

const StyleWrap = styled('div')({
  padding: '8px 10px',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
  '&.optionSelected': {
    background: '#1C365F0A',
    borderRadius: '4px',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      width: '3px',
      height: '16px',
      borderRadius: '3px',
      background: '#0060A9',
      transform: 'translateY(-50%) translateX(-50%)',
    },
  },
  '&:hover': {
    background: '#1C365F0A',
    borderRadius: '4px',
  },
  '&.optionSelected.multiSelect': {
    background: '#1C365F0A',
    borderRadius: '4px',
    position: 'relative',
    '&::after': {
      background: 'transparent',
    },
    '&:hover': {
      background: '#1C365F0A',
      borderRadius: '4px',
    },
  },
});

const Option: React.FC<PropsWithChildren<Props>> = (props) => {
  const { checkIcon, isSelected, checked, children, onClick, multiSelect, ...restProps } = props;

  return (
    <StyleWrap
      className={classNames({ optionSelected: isSelected, multiSelect })}
      onClick={() => onClick?.()}
      {...restProps}
    >
      {checkIcon}
      {children}
    </StyleWrap>
  );
};

export default Option;
